import { createAsyncThunk } from '@reduxjs/toolkit';
import Axios from '../../utils/Axios';
import * as Sentry from '@sentry/gatsby';

export const fetchSelf = createAsyncThunk<User>(
  'user/fetchSelf',
  async (_, { rejectWithValue }) => {
    try {
      const storedMe = localStorage.getItem('me');
      if (storedMe) {
        try {
          const parsed = JSON.parse(storedMe);
          if (parsed && typeof parsed === 'object' && 'cognito_user_id' in parsed) {
            return parsed;
          }
          localStorage.removeItem('me');
        } catch {
          localStorage.removeItem('me');
        }
      }
      const response = await Axios.get(`/contacts/me/`);
      localStorage.setItem('me', JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      Sentry.captureException(error);
      localStorage.removeItem('me');
      return rejectWithValue(error);
    }
  },
);
